import { useNavigate } from 'react-router-dom';
import configData from '../config.json';

import $ from "jquery";

const HamburgerComponent = ({categoryList, setActiveCategory, activeCategory, setActiveVideo }) => {

    let navigate = useNavigate(); 
    const navigateTo = (path) =>{ 
        navigate(path);
    }

    const navigateToHomeFromLogo = (path) =>{ 
        $('.offcanvas-collapse').removeClass('open');
        $('body').removeClass('opened-menu');
        navigate(path);
    }

    const navigateToCategory = (cat) =>{ 
        var path = '/' + (cat.flatName).replace(/\s/g, '-');
        navigate(path);
    }

    const setClassName = (cat) => {

        document.querySelector('a').classList.remove();
        const pathname = window.location.pathname;

        if(cat === "home" && pathname === "/") {
            return "nav-link  active";
        }
        else if(cat.id === activeCategory.id && pathname !== "/") {
          return "nav-link  active";
        }
        else {
          return "nav-link ";
        }
    };

    $('.hamburger-logo').on('click', function () {
        $('.offcanvas-collapse').removeClass('open');
        $('body').removeClass('opened-menu');
     })

    const changeActiveCategory = (cat) =>{ 

        var clickedCategory = {};

        categoryList.forEach(element => {
            if(element.id === cat) {
                clickedCategory = element;
            }
        });

        setActiveCategory(clickedCategory);
        setActiveVideo(clickedCategory.videos[0]);
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(clickedCategory));
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(clickedCategory.videos[0]));

        navigateToCategory(clickedCategory);
    }

    if((configData.BRAND).toUpperCase() === 'DELO'){
        var imgSrcBrand = configData.DELO.LOGO;
        var altImgBrand = configData.DELO.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-delo-logo";
        var copytightBrand = configData.DELO.COPYRIGHTBRAND;
        var hamburgerLinkTitle = configData.DELO.HAMBURGER_LINK_TITLE;
        var hamburgerLink = configData.DELO.HAMBURGER_LINK;
    }
    else {
        var imgSrcBrand = configData.SLOVENSKENOVICE.LOGO;
        var altImgBrand = configData.SLOVENSKENOVICE.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-novice-logo";
        var copytightBrand = configData.SLOVENSKENOVICE.COPYRIGHTBRAND;
        var hamburgerLinkTitle = configData.SLOVENSKENOVICE.HAMBURGER_LINK_TITLE;
        var hamburgerLink = configData.SLOVENSKENOVICE.HAMBURGER_LINK;
    }



    return (
        <>
            <div className="navbar-collapse offcanvas-collapse justify-content-end" id="navbarOffCanvas" data-toggle="offcanvas">
                <header className="d-flex justify-content-center align-items-center">
                    <img src={imgSrcBrand} className="d-logo-sidemenu hamburger-logo" alt={altImgBrand} onClick={() => navigateToHomeFromLogo("/")} />
                </header>
                <div className="d-navbar-scroll">
                    {/* <div className="input-group mb-3 d-side-menu-search px-3">
                        <input type="text" className="form-control rounded-0" placeholder="Search" aria-label="Search" aria-describedby="button-addon2" />
                        <button className="btn btn-outline-primary" type="button" id="sideMenuSearch" aria-label="Search"><i className="fa-regular fa-magnifying-glass"></i></button>
                    </div> */}
                    <ul className="navbar-nav d-sidelinks" id="navbar" data-aos="fade-left">
                        <li className="nav-item">
                            <a className={setClassName("home")} aria-current="page" style={{"cursor": "pointer"}} onClick={() => navigateTo("/")}>Naslovna stran</a>
                        </li>
                        {categoryList && categoryList.map((cat, index) => 
                            <li key={cat.id}><a  className={setClassName(cat)} aria-current="page" style={{"cursor": "pointer"}} onClick={() => {changeActiveCategory(cat.id);}}>{cat.name}</a></li>
                        )}
                    </ul>
                </div>
                <footer className="d-block f-side-menu">
                <a href={hamburgerLink} target={"_blank"} className="d-powered-by-link">{hamburgerLinkTitle}</a>

                    <p className="d-copyright">Copyright © {copytightBrand} {new Date().getFullYear()}</p>
                </footer>
            </div>
        </>
    );
}

export default HamburgerComponent;